import {AbstractBaseService} from "../ensue-react-system/utilities/base-service";
import {EnsueHttpClient} from "../ensue-react-system/http/ensue-http-client";
import {ApiEndPointUriProvider} from "../ensue-react-system/http/ensue-http-types";
import {User} from "../commons/models/user";
import { IUserDTO } from "./manage-user-service";

export class AuthService extends AbstractBaseService<User> {
    protected __model: User = new User();

    public constructor(__client: EnsueHttpClient, __endpointProvider: ApiEndPointUriProvider) {
        super(__client, __endpointProvider);
    }

    public getResourceName(): string {
        return "auth/me";
    }

    public getAuthUser(): Promise<User> {
        return this.__client.get(this.__url);
    }

    public editAuthUser(userData: IUserDTO) {
        return this.__client.patch(this.__url, userData);
    }
}
